/** @file Direction-set controls: count (4 or 8), the 4-layout, and the iso tile synced from the grid. */
import type { DirectionsDoc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { Button } from '../../ui-kit/Button';
import { Select } from '../../ui-kit/Select';
import type { RunCommands } from '../rigKit/rigView';

/** Props of SetControls. */
export interface SetControlsProps {
  t: Translate;
  run: RunCommands;
  set: DirectionsDoc;
}

const COUNTS = [{ value: '4', label: '4' }, { value: '8', label: '8' }];

/** direction.setCount / setLayout4 / syncIso; entries a smaller set cannot hold are dropped by the command (a warning lists them). */
export function SetControls({ t, run, set }: SetControlsProps) {
  const layouts = [{ value: 'diagonal', label: t('panels.directions.diagonal') }, { value: 'cardinal', label: t('panels.directions.cardinal') }];
  const iso = set.iso === undefined ? t('panels.directions.noIso') : t('panels.directions.iso', { w: set.iso[0], h: set.iso[1] });
  return (
    <div className="rig-row">
      <Select label={t('panels.directions.count')} value={String(set.count)} options={COUNTS} onChange={(v) => { run([{ name: 'direction.setCount', input: { count: v === '8' ? 8 : 4 } }]); }} />
      {set.count === 4 && (
        <Select label={t('panels.directions.layout')} value={set.layout4 ?? 'diagonal'} options={layouts} onChange={(layout4) => { run([{ name: 'direction.setLayout4', input: { layout4 } }]); }} />
      )}
      <span className="rig-note">{iso}</span>
      <Button label={t('panels.directions.syncIso')} onClick={() => { run([{ name: 'direction.syncIso', input: {} }]); }} />
    </div>
  );
}
